export const locale = {
    lang: 'vn',
    data: {
        "TOOLBAR": {
            'CHANGE_PASSWORD': "Đổi mật khẩu",
            "LOGOUT": "Đăng xuất"
        }
    }
};